import {
  BidStatus,
  NegotiationRoundStatus,
  type EvalBidDto,
  type EvaluationDto,
  type NegotiationRoundDto,
} from "../../../autogen/bff-api";

export const isFullyScored = (bid: EvalBidDto): boolean =>
  bid.cells.filter((cell) => !cell.isAutoComputed).every((cell) => cell.points != null);

export const unscoredRoundTenders = (
  latestRoundEvaluation: EvaluationDto | null | undefined,
  rounds: readonly NegotiationRoundDto[],
): EvalBidDto[] => {
  const afterRounds = rounds.some((round) => round.status !== NegotiationRoundStatus.Draft);
  if (!afterRounds || latestRoundEvaluation == null) return [];
  return latestRoundEvaluation.bids.filter((bid) => bid.status !== BidStatus.Rejected && !isFullyScored(bid));
};

export const everyScoreIn = (evaluation: EvaluationDto | null | undefined): boolean => {
  if (evaluation == null) return false;
  const rankable = evaluation.bids.filter((bid) => bid.status !== BidStatus.Rejected);
  return (
    rankable.length > 0 &&
    evaluation.progress.filled >= evaluation.progress.total
  );
};
